export default {
	STATISTICS_COUNT: (state, data) => {
		state.count = data;
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/home/mutations.js